import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { AppHeader } from 'components';

import useStyles from './styles';

const StripeInstruction = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <>
      <AppHeader />
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography variant="h1" className={classes.title}>
            {t('How to add Stripe to your website')}
          </Typography>
          <Typography variant="body1" className={classes.paragraph}>
            {t('For configuring the Stripe Payment method')}
          </Typography>
          <Typography variant="body1">
            <ol>
              <li className={classes.listItem}>{t('Log into')}</li>
              <li className={classes.listItem}>
                {t(
                  "In the main Dashboard screen, you'll see a menu on the left side."
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'While on the API Keys page, click on the View Test Data slider button in the upper righthand corner.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Copy the Publishable Key and Secret Key from the Token column (use test keys for testing purposes and live keys for real payments mode).'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Go to the Horn Admin Portal and select Settings on the horizontal navigation bar.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'On the Payment Settings page add the new panel and select “Stripe” in the drop-down.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Paste copied Publishable Key and Secret Key values into appropriate fields and Save the page.'
                )}
              </li>
            </ol>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default StripeInstruction;
